'use client';

import { useTranslations } from '@dealerportal/i18n/client';
import { ListItem } from './VerticalMultiMenu';

interface Props {
  attribs: any;
  className: any;
  name: any;
}

export const MenuItemBase: React.FC<Props> = (props) => {
  const t = useTranslations('ui');
  const { attribs, className, name } = props;
  const { text, href } = attribs;

  if (attribs['type'] === 'phoneto') {
    const isPhoneNumber =
      /^tel:\s*(?:\+?1\s*)?\(?(\d{3})\)?[-.\s]*(\d{3})[-.\s]*(\d{4})$/.test(
        attribs['href']
      );

    const hrefWithTel = isPhoneNumber
      ? attribs['href']
      : `tel:${attribs['href']}`;

    return (
      <nav>
        <ul id={`ul_${name}`} className={`accord ${className}`}>
          <li id={`li_${name}`}>
            <a
              role="menuitem"
              style={{ display: 'block' }}
              className={`${className}_item`}
              onClick={(e) => {
                e.preventDefault();
                window.open(hrefWithTel, '_self');
                return false;
              }}
              href={hrefWithTel}
              aria-label={`${t('linkTo')} ${text}`}
              data-ctm-watch-id="1"
              data-ctm-tracked="1"
              data-observe="1"
              data-observer-id="0"
              data-ctm-remark="1"
            >
              <div className={`${className}_txt`} style={{ float: 'left' }}>
                {text}
              </div>
              <div style={{ clear: 'both' }} />
            </a>
          </li>
        </ul>
      </nav>
    );
  }

  if (attribs['text'] === 'Schedule an estimate') {
    return (
      <nav>
        <ul id={`ul_${name}`} className={`accord ${className}`}>
          <li id={`li_${name}`}>
            <a
              role="menuitem"
              style={{ display: 'block' }}
              className={`${className}_item`}
              onClick={(e) => {
                e.preventDefault();
                window.open(href, '_self');
                return false;
              }}
              href={href}
              aria-label={`${t('linkTo')} ${text}`}
              data-ctm-watch-id="1"
              data-ctm-tracked="1"
              data-observe="1"
              data-observer-id="0"
              data-ctm-remark="1"
            >
              <div className={`${className}_txt`} style={{ float: 'left' }}>
                {text}
              </div>
              <div style={{ clear: 'both' }} />
            </a>
          </li>
        </ul>
      </nav>
    );
  }

  return <ListItem key={href} href={href} text={text} className={className} />;
};

export default MenuItemBase;
